export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "start_module_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passer le module"])},
        "sellers_trained": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("passed")), " / ", _interpolate(_named("total")), " vendeurs formés · ", _interpolate(_named("percent")), " % de l'équipe"])},
        "no_stats": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun vendeur n'a encore commencé ce module"])}
      },
      "en": {
        "start_module_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Take the module"])},
        "sellers_trained": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("passed")), " / ", _interpolate(_named("total")), " sellers trained · ", _interpolate(_named("percent")), "% of the team"])},
        "no_stats": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No seller has started this module yet"])}
      }
    }
  })
}
